import React from "react";

const MapTooltip = ({ objectToDisplay, pointerX, pointerY }) => {
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 3,
        pointerEvents: "none",
        left: pointerX,
        top: pointerY,
        ...styles.tooltipContainer,
      }}
    >
      <span style={styles.title}>{objectToDisplay.title}</span>
      <br />
      <span style={styles.description}>{objectToDisplay.description}</span>
    </div>
  );
};

const styles = {
  tooltipContainer: {
    backgroundColor: "var(--color-white)",
    padding: 12,
    boxShadow: "0 2px 4px 0 rgba(0,0,0,.24)",
    borderRadius: 4,
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
  },
  description: {
    fontSize: 14,
    whiteSpace: "pre-line",
  },
};

export default MapTooltip;
